<template>
<div class="cmp cmp-evaluate-project-student">
  <cmpCard :showFooter="false">
    <div slot="header">
      <el-row type="flex">
        <el-col :span="16" class="left">
          <strong>项目评价</strong>
        </el-col>
        <el-col :span="4" class="middle text-right">
          <strong style="color: #19A4FF;">项目总体评价：</strong>
        </el-col>
        <el-col :span="4" class="right">
          <x-star-bar type="warning" :size="24" fill disabled :index="studentProjectEvaluate.teacherStar"></x-star-bar>
        </el-col>
      </el-row>
    </div>
    <div slot="body">
      <el-row type="flex" :gutter="20">
        <el-col :span="6">
          <div class="panel">
            <div class="panel-header">信息意识</div>
            <div class="panel-body">
              <x-star-bar type="warning" :size="24" fill disabled :index="studentProjectEvaluate.informationStar"></x-star-bar>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="panel">
            <div class="panel-header">计算思维</div>
            <div class="panel-body">
              <x-star-bar type="warning" :size="24" fill disabled :index="studentProjectEvaluate.thinkingStar"></x-star-bar>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="panel">
            <div class="panel-header">数字化学习与创新</div>
            <div class="panel-body">
              <x-star-bar type="warning" :size="24" fill disabled :index="studentProjectEvaluate.digitalStar"></x-star-bar>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="panel">
            <div class="panel-header">信息社会责任</div>
            <div class="panel-body">
              <x-star-bar type="warning" :size="24" fill disabled :index="studentProjectEvaluate.societyStar"></x-star-bar>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </cmpCard>
</div>
</template>

<script>
import cmpCard from '@/components/cmpCard.vue'
import publicUrl from '@/assets/js/interface'

export default {
  name: 'cmp-evaluate-project-student',
  components: {
    cmpCard
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      studentProjectEvaluate: {},
      loadingCount: 0
    }
  },
  created () {
    if (this.$route.query.projectId) {
      this.getStudentProjectEvaluate()
    }
  },
  methods: {
    getStudentProjectEvaluate () {
      this.loadingCount++
      this.studentProjectEvaluate = {}
      this.$ajax.get(publicUrl.studentProjectEvaluate, {
        params: {
          projectId: this.$route.query.projectId,
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.studentProjectEvaluate = res.data.data || {}
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cmp-evaluate-project-student {
  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #464C5B;
    line-height: 2;
  }
  p {
    font-size: 16px;
    color: #464C5B;
    line-height: 2;
  }
  .panel {
    margin: 10px auto;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 0 10px #dedede;
    .panel-header,
    .panel-body {
      padding: 0 30px;
      height: 60px;
      line-height: 60px;
    }
    .panel-header {
      font-size: 20px;
      font-weight: 500;
      color: #19A4FF;
      border-bottom: 1px solid #DDE2E6;
    }
  }
  .x-star-bar {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
